module.exports = __webpack_public_path__ + "img/s12.982f707c.png";